import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { configData } from '../Whitelabel/websitesData';

export function useRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Only proceed if urlRedirect exists
    if (configData.urlRedirect) {
      const currentPath = location.pathname;
      
      // Check if current path exists in urlRedirect
      if (currentPath in configData.urlRedirect) {
        const redirectPath = configData.urlRedirect[currentPath];
        
        // console.log('Redirecting:', {
        //   from: currentPath,
        //   to: redirectPath || '/',
        //   isEmpty: !redirectPath
        // });
        
        // If redirectPath is empty, navigate to homepage, otherwise use the specified path
        navigate(redirectPath || '/', { replace: true });
      } else if (currentPath.includes('MLB')) {
        navigate('/', { replace: true });
      }
    }
  }, [location.pathname, navigate]);
}